// @flow
import { useState, useEffect } from 'react';
import debounce from 'lodash-es/debounce';

export default function useWindowDimensions(): {
  width: ?number,
  height: ?number,
} {
  const hasWindow = typeof window !== 'undefined';

  function getWindowDimensions() {
    const width = hasWindow ? window.innerWidth : null;
    const height = hasWindow ? window.innerHeight : null;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  function handleResize() {
    setWindowDimensions(getWindowDimensions());
  }

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (hasWindow) {
      window.addEventListener('resize', debounce(handleResize, 300));
      return () => window.removeEventListener('resize', handleResize);
    }
  }, [hasWindow]);

  return windowDimensions;
}
